import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
} from 'omakase/utils/OmakasePolymorphicComponent';
import {
  PadButtonCore,
  PadButtonCoreProps,
  PadButtonDefaultElement,
} from 'omakase/PadButton/PadButtonCore';
import React from 'react';

export type SwitcherProps = Omit<PadButtonCoreProps, 'decorativeElement'>;

export type SwitcherTypeGuard = 'input';

const Switcher: OmakasePolymorphicComponent<
  SwitcherProps,
  typeof PadButtonDefaultElement,
  SwitcherTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof PadButtonDefaultElement>(
    { component, ...rest }: OmakasePolymorphicComponentProps<SwitcherProps, E, SwitcherTypeGuard>,
    ref: React.Ref<HTMLInputElement> | undefined
  ) => {
    const Component: React.ElementType = component || PadButtonDefaultElement;

    return (
      <PadButtonCore
        {...rest}
        component={Component}
        ref={ref}
        borderRadius="large"
        verticalSpacing="small"
      />
    );
  }
);

export default Switcher;
